"use client";

import type { UseOpenApiMutationOptions } from "@packages/sdk";
import { useOpenApiMutation } from "@packages/sdk";

const urlBackendPath = "/me/pin" as const;

export const useRequestMePinPut = (
  props: Partial<UseOpenApiMutationOptions<typeof urlBackendPath, "PUT">> = {},
) =>
  useOpenApiMutation({
    method: "PUT",
    urlBackendPath,
    ...props,
  });
